import {AnyAction} from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
// import {AnyAction, isAnyOf} from '@reduxjs/toolkit'

// import {initOrderSheetByAPI, initOrderSheetByStorage} from '$actions'

// TODD: 순환참조 해결을 위해 임시 주석처리 합니다. 릴리즈 전 해결이 필요합니다.
/** 개인정보가 포함된 payload를 전달하는 액션 */
// const isSensitiveAction = (action: AnyAction): boolean =>
//     isAnyOf(initOrderSheetByAPI.fulfilled, initOrderSheetByStorage.fulfilled)(action)
const isSensitiveAction = (_action: AnyAction): boolean => false

export type EnhancerOptions = Parameters<typeof Sentry.createReduxEnhancer>[0]

/** Sentry Redux Enhancer */
export default (enhancerOptions?: EnhancerOptions) =>
    Sentry.createReduxEnhancer({
        ...enhancerOptions,
        actionTransformer(action) {
            if (isSensitiveAction(action)) {
                return {
                    ...action,
                    payload: undefined,
                }
            }
            if (enhancerOptions?.actionTransformer) {
                return enhancerOptions.actionTransformer(action)
            }
            return action
        },
    })
